import * as tslib_1 from "tslib";
import jsonp from 'jsonp';
import API_BASE from '@/services/config';
import authIns from '@/shared/authz';
import './assets/common.less';
// 获取登录信息
function fetchLoginInfo() {
    return new Promise((resolve, reject) => {
        jsonp(`${API_BASE.getAuthz}/httpApi/getAuthZ.jsonp`, {}, (err, data) => {
            if (data.success) {
                // 通过登录来获取用户信息
                authIns.setAuthData(data.data);
                // // 接入消息推送sdk;
                // connectDatacenterNotice({
                //   product: 'PORTRAIT',
                //   phone: data.data.userPhone,
                //   theme: 'dark',
                // });
            }
            resolve();
        });
    });
}
// 是否已登录并且拿到权限列表
export default function bootstrap() {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        yield new Promise((resolve, reject) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield fetchLoginInfo();
            resolve();
        }));
    });
}
